export const USER_GENERAL_FETCH_SUCCESSFULLY = "general.USER_GENERAL_FETCH_SUCCESSFULLY";
export const USER_GENERAL_FETCH_FAILED = "general.USER_GENERAL_FETCH_FAILED";
export const GENERAL_FREEZE_USER = "general.GENERAL_FREEZE_USER";
export const USER_GENERAL_UPDATE_COMMUNICATION_SETTINGS =
	"general.USER_GENERAL_UPDATE_COMMUNICATION_SETTINGS";
export const USER_GENERAL_UPDATE_SETTINGS_SETTINGS =
	"general.USER_GENERAL_UPDATE_SETTINGS_SETTINGS";
export const GENERAL_UNFREEZE_USER = "general.GENERAL_UNFREEZE_USER";
export const GENERAL_DELETE_USER = "general.GENERAL_DELETE_USER";
